import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { APIDestination } from '../../../../../../../typings/Destination.interface';
import { ClickableArea, ClickableAreaProps } from '../../../common/base/Button';
import { StyledCard } from '../../../common/base/Card';
import Icon, { IconName } from '../../../common/base/Icon';
import Text from '../../../common/base/Text';
import Tooltip from '../../../common/base/Tooltip';
import { Div } from '../../../common/helpers/StyledUtils';
import { Truncatable } from '../../../common/Truncatable';
import { DashboardContext } from '../DashboardContext';
import DeliveryGroupsIndicator from './DeliveryGroupsIndicator';
import { getDestinationDeliveryPolicy } from './Forms/destination_configuration';
interface Props extends Pick<ClickableAreaProps, 'to' | 'onClick'> {
  destination: APIDestination;
}
const DestinationCard: React.FC<Props> = t0 => {
  const $ = _c(30);
  const {
    destination,
    onClick,
    to
  } = t0;
  const {
    destination_types
  } = useContext(DashboardContext);
  const destination_type = destination_types?.[destination?.type];
  let t1;
  if ($[0] !== destination) {
    t1 = getDestinationDeliveryPolicy(destination);
    $[0] = destination;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const delivery_policy = t1;
  const delivery_groups = delivery_policy?.groups;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      x: 2,
      y: 1.5
    };
    t3 = {
      justify: "space-between",
      align: "center"
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      align: "center",
      justify: "space-between"
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      align: "center"
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== destination_type) {
    t6 = destination_type?.icon && <Icon icon={destination_type.icon as IconName} muted={true} left={true} pointer={true} />;
    $[6] = destination_type;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = !!destination.disabled_at;
  let t8;
  if ($[8] !== destination.name) {
    t8 = <Truncatable text={destination.name} />;
    $[8] = destination.name;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t7 || $[11] !== t8) {
    t9 = <Text w={100} ellipsis={true} mono={true} muted={t7}>{t8}</Text>;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t6 || $[14] !== t9) {
    t10 = <Div flex={t5} w={100}>{t6}{t9}</Div>;
    $[13] = t6;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== destination.disabled_at) {
    t11 = destination.disabled_at && <Tooltip tooltip="Disabled" side="bottom"><Icon muted={true} icon="disable" right={true} pointer={true} /></Tooltip>;
    $[16] = destination.disabled_at;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== delivery_groups || $[19] !== delivery_policy || $[20] !== destination.disabled_at) {
    t12 = delivery_groups && !destination.disabled_at ? <DeliveryGroupsIndicator groups={delivery_groups} left={true} /> : delivery_policy?.rate && !destination.disabled_at ? <Tooltip side="bottom" tooltip={delivery_policy.period === "concurrent" ? `Max delivery rate of ${delivery_policy.rate} concurrent` : `Max delivery rate of ${delivery_policy.rate} per ${delivery_policy.period}`}><Icon icon="rate_limit" right={true} muted={true} pointer={true} /></Tooltip> : null;
    $[18] = delivery_groups;
    $[19] = delivery_policy;
    $[20] = destination.disabled_at;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t10 || $[23] !== t11 || $[24] !== t12) {
    t13 = <Div flex={t4} w={100}>{t10}{t11}{t12}</Div>;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== onClick || $[27] !== t13 || $[28] !== to) {
    t14 = <StyledCard overflow_hidden={true} borderless={true}><ClickableArea p={t2} flex={t3} onClick={onClick} to={to}>{t13}</ClickableArea></StyledCard>;
    $[26] = onClick;
    $[27] = t13;
    $[28] = to;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  return t14;
};
export default DestinationCard;